module.exports = __webpack_public_path__ + "static/media/ro.af4f1a84.svg";